import type { ModelData } from '../../types'

export const nemoProste: { [key: string]: ModelData } = {
  'nemo-2': {
    id: 'nemo-2',
    name: 'NEMO 2',
    power: '16 kW',
    type: 'wodny',
    glassType: 'prosta' as const,
    image: 'images/nemo-2.jpg',
    emailSubject: 'Zapytanie - NEMO 2',
    description: 'Wkład wodny prosty 16 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 10970, 
        double: 11610, 
        triple: 12360
      },
      lift: { 
        single: 13910, 
        double: 14560, 
        triple: 15310
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          'none': 0, 
          'flush-15': 360,
          'flush-30': 410,
          'recessed-15': 450,
          'recessed-30': 530,
          'recessed-15-45': 560
        },
        lift: { 
          'none': 0, 
          'recessed-lift-15': 430,
          'recessed-lift-30': 500,
          'recessed-lift-5': 950
        }
      },
      fusion: {
        'none': 0,
        'fusion': 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard - otwieranie na bok', 
        'lift': 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2', 
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '16 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '6,2-12,0 kW',
      waterCapacity: '49 dm³',
      glassSize: '655 x 471 mm',
      insertSize: '708 x 1400-1555 x 450 mm',
      fireplaceSize: '445 x 500 x 254 mm',
      maxLogLength: '500 mm',
      weight: '240 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 2',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 2 w konfiguracji:\n\nModel: NEMO 2\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-2-xl': {

    id: 'nemo-2-xl',

    name: 'NEMO 2 XL',
    power: '16 kW',
    type: 'wodny',
    glassType: 'prosta' as const,
    image: 'images/nemo-2-xl.jpg',
    emailSubject: 'Zapytanie - NEMO 2 XL',
    description: 'Wkład wodny prosty 16 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 11450, 
        double: 12150, 
        triple: 12900
      },
      lift: { 
        single: 14400, 
        double: 15090, 
        triple: 15840
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 370,
          'flush-30': 420,
          'recessed-15': 490,
          'recessed-30': 550,
          'recessed-15-45': 600
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 440,
          'recessed-lift-30': 510,
          'recessed-lift-5': 960
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '16,5 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '6,2-12,0 kW',
      waterCapacity: '33 dm³',
      glassSize: '655 x 514 mm',
      insertSize: '708 x 1443-1598 x 450 mm',
      fireplaceSize: '488 x 500 x 254 mm',
      maxLogLength: '500 mm',
      weight: '243 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 2 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 2 XL w konfiguracji:\n\nModel: NEMO 2 XL\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-4-slim': {

    id: 'nemo-4-slim',

    name: 'NEMO 4 SLIM',
    power: '20 kW',
    type: 'wodny nofusion',
    glassType: 'prosta' as const,
    image: 'images/nemo-4-slim.jpg',
    emailSubject: 'Zapytanie - NEMO 4 SLIM',
    description: 'Wkład wodny prosty 20 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 11940, 
        double: 12680, 
        triple: 13490
      },
      lift: { 
        single: 14880, 
        double: 15630, 
        triple: 16430
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 390,
          'flush-30': 430,
          'recessed-15': 500,
          'recessed-30': 560,
          'recessed-15-45': 630
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 450,
          'recessed-lift-30': 530,
          'recessed-lift-5': 990
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '19 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '8,0-14,0 kW',
      waterCapacity: '44 dm³',
      glassSize: '717 x 471 mm',
      insertSize: '790 x 1473-1628 x 474 mm',
      fireplaceSize: '438 x 596 x 285 mm',
      maxLogLength: '550 mm',
      weight: '297 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 4 SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 4 SLIM w konfiguracji:\n\nModel: NEMO 4 SLIM\nMoc: 20 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-4': {

    id: 'nemo-4',

    name: 'NEMO 4',
    power: '21 kW',
    type: 'wodny',
    glassType: 'prosta' as const,
    image: 'images/nemo-4.jpg',
    emailSubject: 'Zapytanie - NEMO 4',
    description: 'Wkład wodny prosty 21 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 12420, 
        double: 13170, 
        triple: 13970
      },
      lift: { 
        single: 15360, 
        double: 16110, 
        triple: 16910
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 390,
          'flush-30': 430,
          'recessed-15': 500,
          'recessed-30': 560,
          'recessed-15-45': 630
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 450,
          'recessed-lift-30': 530,
          'recessed-lift-5': 990
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '24 kW',
      efficiency: '89,9%',
      energyClass: 'A+',
      waterHeaterPower: '8,7-16,0 kW',
      waterCapacity: '59 dm³',
      glassSize: '717 x 471 mm',
      insertSize: '781 x 1479-1634 x 574 mm',
      fireplaceSize: '438 x 564 x 370 mm',
      maxLogLength: '550 mm',
      weight: '331 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 4',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 4 w konfiguracji:\n\nModel: NEMO 4\nMoc: 21 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-6': {

    id: 'nemo-6',

    name: 'NEMO 6',
    power: '17 kW',
    type: 'wodny nofusion',
    glassType: 'prosta' as const,
    image: 'images/nemo-6.jpg',
    emailSubject: 'Zapytanie - NEMO 6',
    description: 'Wkład wodny prosty 17 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 11450, 
        double: 12200, 
        triple: 13010
      },
      lift: { 
        single: 14400, 
        double: 15150, 
        triple: 15950
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 360,
          'flush-30': 410,
          'recessed-15': 470,
          'recessed-30': 540,
          'recessed-15-45': 580
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 420,
          'recessed-lift-30': 500,
          'recessed-lift-5': 950
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '18 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '6,5-14,0 kW',
      waterCapacity: '50 dm³',
      glassSize: '754 x 381 mm',
      insertSize: '824 x 1302-1457 x 444 mm',
      fireplaceSize: '370 x 605 x 254 mm',
      maxLogLength: '600 mm',
      weight: '220 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 6',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 6 w konfiguracji:\n\nModel: NEMO 6\nMoc: 17 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-6-xl': {

    id: 'nemo-6-xl',

    name: 'NEMO 6 XL',
    power: '18 kW',
    type: 'wodny',
    glassType: 'prosta' as const,
    image: 'images/nemo-6-xl.jpg',
    emailSubject: 'Zapytanie - NEMO 6 XL',
    description: 'Wkład wodny prosty 18 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 11990, 
        double: 12840, 
        triple: 13810
      },
      lift: { 
        single: 14930, 
        double: 15790, 
        triple: 16750
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 390,
          'flush-30': 440,
          'recessed-15': 500,
          'recessed-30': 560,
          'recessed-15-45': 630
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 450,
          'recessed-lift-30': 530,
          'recessed-lift-5': 990
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '18 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '6,5-14,0 kW',
      waterCapacity: '50 dm³',
      glassSize: '754 x 454 mm',
      insertSize: '824 x 1375-1530 x 444 mm',
      fireplaceSize: '440 x 605 x 254 mm',
      maxLogLength: '600 mm',
      weight: '259 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 6 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 6 XL w konfiguracji:\n\nModel: NEMO 6 XL\nMoc: 18 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-8': {

    id: 'nemo-8',

    name: 'NEMO 8',
    power: '22 kW',
    type: 'wodny nofusion',
    glassType: 'prosta' as const,
    image: 'images/nemo-8.jpg',
    emailSubject: 'Zapytanie - NEMO 8',
    description: 'Wkład wodny prosty 22 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 9690, 
        double: 10280, 
        triple: 10970
      },
      lift: { 
        single: 12630, 
        double: 13220, 
        triple: 13910
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 300,
          'flush-30': 350,
          'recessed-15': 390,
          'recessed-30': 440,
          'recessed-15-45': 490
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 360,
          'recessed-lift-30': 410,
          'recessed-lift-5': 780
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '5,0-10,0 kW',
      waterCapacity: '20 dm³',
      glassSize: '423 x 513 mm',
      insertSize: '521 x 1305-1381 x 517 mm',
      fireplaceSize: '495 x 382 x 360 mm',
      maxLogLength: '360 mm',
      weight: '196 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 8',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 8 w konfiguracji:\n\nModel: NEMO 8\nMoc: 22 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-9': {

    id: 'nemo-9',

    name: 'NEMO 9',
    power: '20 kW',
    type: 'wodny nofusion',
    glassType: 'prosta' as const,
    image: 'images/nemo-9.jpg',
    emailSubject: 'Zapytanie - NEMO 9',
    description: 'Wkład wodny prosty 20 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: { 
        single: 13490, 
        double: 14450, 
        triple: 15630
      },
      lift: { 
        single: 16430, 
        double: 17390, 
        triple: 18570
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 420,
          'flush-30': 500,
          'recessed-15': 550,
          'recessed-30': 640,
          'recessed-15-45': 690
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 510,
          'recessed-lift-30': 580,
          'recessed-lift-5': 1100
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '19 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '6,5-14,0 kW',
      waterCapacity: '43 dm³',
      glassSize: '904 x 454 mm',
      insertSize: '957 x 1362-1517 x 441 mm',
      fireplaceSize: '415 x 807 x 260 mm',
      maxLogLength: '600 mm',
      weight: '310 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 9',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 9 w konfiguracji:\n\nModel: NEMO 9\nMoc: 20 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  }
}
